import type { Plan } from "../claw-config";

/**
 * Subscription plan-card catalog for the Settings page.
 *
 * Display copy is domain-owned (frontend-doctrine §4.11) — components render
 * these entries rather than raw plan literals. "Always-on agent" and
 * "Increased storage" are forward-looking benefits: listed on the card ahead
 * of enforcement (idle-reap exemption and storage tiers are not shipped yet).
 */
export interface SubscriptionPlanCard {
  readonly plan: Extract<Plan, "trial" | "standard">;
  readonly title: string;
  readonly priceLine: string;
  readonly benefits: readonly string[];
}

export const SUBSCRIPTION_PLAN_CARDS: readonly SubscriptionPlanCard[] = [
  {
    plan: "trial",
    title: "Pay as you go",
    priceLine: "No monthly fee",
    benefits: ["Buy credit packs as you go", "Agent sleeps when idle"],
  },
  {
    plan: "standard",
    title: "Standard",
    priceLine: "$19.99/mo",
    benefits: [
      "1,000 credits included monthly",
      "Always-on agent (no wake time)",
      "Cron jobs / scheduled tasks",
      "Increased storage",
    ],
  },
];
